// extracted by mini-css-extract-plugin
export default {"vlButton":"style_vlButton__RqyuC","gradient":"style_gradient__xns9G"};